export const STORAGE_KEYS = {
    LANGUAGE: 'language',
};
